/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Upload_TitleInputs */

const en_ui_onboarding_upload_title = /** @type {(inputs: Ui_Onboarding_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your FIT files`)
};

const de_ui_onboarding_upload_title = /** @type {(inputs: Ui_Onboarding_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge deine FIT-Dateien hinzu`)
};

/**
* | output |
* | --- |
* | "Add your FIT files" |
*
* @param {Ui_Onboarding_Upload_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_upload_title = /** @type {((inputs?: Ui_Onboarding_Upload_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Upload_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_upload_title(inputs)
	return de_ui_onboarding_upload_title(inputs)
});